import {
  TextInput,
  SelectInput,
  required,
  ReferenceInput,
  BooleanInput,
  NumberInput,
  minValue,
  maxValue,
} from "react-admin";
import { Grid, Typography } from "@mui/material";
import { useWatch } from "react-hook-form";
import { GenderOptionsId } from "utils/choices";
import { specialistRequests } from "api/specialistApi";
import CustomDateInput from "server/components/Fields/CustomDateInput";

const SaveForm = ({ isEdit }) => {
  const advancedSpecializationId = useWatch({ name: "advancedSpecializationId" });

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="firstName"
          label="Име"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="secondName"
          label="Презиме"
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="lastName"
          label="Фамилия"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="personId"
          label="ЕГН/ЛНЧ"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <SelectInput
          source="gender"
          label="Пол"
          choices={GenderOptionsId}
          optionText="name"
          optionValue="id"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          source="advancedSpecializationId"
          reference={specialistRequests.getAdvancedSpecializationsSelect()}
        >
          <SelectInput
            label="ВСД Специалност"
            optionText="nameBg"
            validate={required()}
            emptyText={false}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <BooleanInput
          source="specializedAtMuSofia"
          label="Специализиран в МУ София?"
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <NumberInput
          source="tuitionFeeDiscountPercentage"
          label="Процент отстъпка от такса за обучение"
          validate={[required(), minValue(0), maxValue(100)]}
          onWheel={e => e.target.blur()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <NumberInput
          source="documentProcessingFeeDiscountPercentage"
          label="Процент отстъпка от такса за обработка на документи"
          validate={[required(), minValue(0), maxValue(100)]}
          onWheel={e => e.target.blur()}
        />
      </Grid>
      {!isEdit && advancedSpecializationId && (
        <>
          <Grid
            item
            xs={12}
          >
            <Typography
              color="primary"
              sx={{ marginTop: "2rem" }}
            >
              Първоначален период
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <CustomDateInput
              source="initialPeriod.startDate"
              label="Начална дата"
              validate={required()}
              noTime
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <NumberInput
              source="initialPeriod.durationInDays"
              label="Продължителност (дни)"
              validate={[required(), minValue(1)]}
              onWheel={e => e.target.blur()}
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <ReferenceInput
              source="initialPeriod.buildingId"
              reference={specialistRequests.getAdvancedSpecializationsBuildingsSelect(advancedSpecializationId)}
            >
              <SelectInput
                label="Сграда"
                optionText="buildingNameBg"
                validate={required()}
                fullWidth
              />
            </ReferenceInput>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <ReferenceInput
              source="initialPeriod.professorId"
              reference={specialistRequests.getProfessorsByAdvancedSpecializationSelect(advancedSpecializationId)}
            >
              <SelectInput
                label="Преподавател"
                optionText="names"
                emptyText={false}
                validate={required()}
                fullWidth
              />
            </ReferenceInput>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default SaveForm;
